import { lg, xl } from '../common';
import { gsap } from 'gsap';
import { lerp } from '../lib/math';

export function initCartridges() {
  const parent = document.querySelector('.cartridges');
  if (!parent) return;

  const infoBlock = parent.querySelector('.cartridges__info-block');
  const items = parent.querySelectorAll('.cartridges__item');
  const total = items.length;

  const cartridgesTl = gsap.timeline({
    paused: true,
    defaults: { ease: 'none' },
  });
  const rotateInit = -30;

  items.forEach((item) => {
    cartridgesTl.set(item, {
      transformStyle: 'preserve-3d',
      transformOrigin: 'right center',
      rotateZ: rotateInit,
      z: 0,
      y: 0,
      opacity: 0,
    });
  });

  const durationStepMin = 0.2;
  const durationStepMax = 0.4;
  const durationStep = 0.2;
  const zStep = -200;
  const yStep = -80;
  const rotateStep = 15;
  const opacityStep = 0.32;
  const blurStep = 2;
  let t = 0;

  items.forEach((item, i) => {
    const durationStep = lerp(i, 0, total, durationStepMin, durationStepMax);
    const j = total - i;
    const z = zStep * j;
    const yPercent = (j - 1) * yStep;
    const rotateZ = rotateInit + rotateStep * j;

    const duration = durationStep * j;

    cartridgesTl.to(
      item,
      {
        z,
        yPercent,
        rotateZ,
        duration,
      },
      t,
    );

    const minOpacity = Math.max(0, 1 - (j - 1) * opacityStep);
    const maxBlur = Math.min((j - 1) * blurStep, 8);
    cartridgesTl.to(item, { opacity: 1, duration: durationStep }, t);
    cartridgesTl.to(
      item,
      {
        opacity: minOpacity,
        filter: `blur(${maxBlur}px)`,
        duration: durationStep * 2,
      },
      t + durationStep,
    );

    t += durationStep;
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: parent,
      start: 'top bottom-=200',
      once: true,
      // markers: true,
    },
  });
  tl.to(cartridgesTl, {
    duration: 3,
    progress: 1,
    ease: 'power1.out',
  });

  tl.fromTo(
    '.cartridges__footnote-icon img',
    { rotate: 0 },
    { rotate: 180, duration: 1 },
    '>-=1',
  );
  tl.fromTo(
    '.cartridges__footnote-text',
    { opacity: 0, xPercent: 100 },
    { opacity: 1, xPercent: 0, duration: 1 },
    '<',
  );

  gsap.matchMedia().add(`(min-width: ${lg}px)`, () => {
    tl.to(infoBlock, { opacity: 1, x: 0 }, '<+=0.5');
  });
}
